import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import MaterialTable from 'react-data-table-component';
import {useTranslation} from 'react-i18next';
import i18next from 'i18next';

function VisitInventory(props) {
    const {t} = useTranslation();
    const spareParts = props.spareParts || [];
    const totalQuantity = spareParts.reduce((sum, row) => sum + (row.quantity || 0), 0);

    const columns = [
        {
            name: 'TNR',
            selector: row => row.spare_part?.tnr,
            sortable: true,
        },
        {
            name: t('globalTables.sparePartColumns.name'),
            selector: row => row.spare_part?.name,
            sortable: true,
        },
        {
            name: t('globalTables.sparePartColumns.quantity'),
            selector: row => row.quantity,
            sortable: true,
        },
    ];

    if (!spareParts) {
        return (
            <Grid container justifyContent="center" style={{padding: "20px"}}>
                <CircularProgress size={50} />
            </Grid>
        );
    }

    return (
        <React.Fragment>
            <Grid style={{marginTop: "15px"}} container spacing={1}>
                <Grid item xs={12}>
                    <MaterialTable
                        noHeader={true}
                        columns={columns}
                        data={spareParts}
                        responsive={true}
                        highlightOnHover={true}
                        striped={true}
                        noDataComponent={i18next.t('globalText.NoDataComponent')}
                        paginationComponentOptions={{
                            rowsPerPageText: i18next.t('globalText.rowsPerPageText'),
                            rangeSeparatorText: i18next.t('globalText.rangeSeparatorText'),
                            noRowsPerPage: false,
                            selectAllRowsItem: false,
                            selectAllRowsItemText: i18next.t('globalText.selectAllRowsItemText')
                        }}
                    />
                    <div style={{display: 'flex', justifyContent: 'flex-end', padding: '8px 16px', fontWeight: 'bold'}}>
                        {t('globalTables.sparePartColumns.quantity')}: {totalQuantity}
                    </div>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

export default VisitInventory;
